
import Vue from 'vue'
import * as Api from '@/api/PartyIdentityUserApi'
import { PartyIdentityUserDto } from '@ViewModels/PartyIdentityUserDto'
import { DeleteButton } from '@/components/buttons'

export default Vue.extend({
   name: 'DeleteUser',
   props: { schoolId: String, editingItem: Object as () => PartyIdentityUserDto },
   data() {
      return {
         processing: false,
         processed: false,
      }
   },
   methods: {
      async action() {
         this.processing = true
         try {
            await Api.deletePartyIdentityUser(this.editingItem.UserName)
            this.processing = false
            this.processed = true
         } catch {
            this.processing = false
         }
      },
   },
   components: {
      DeleteButton,
   },
})
